__turbopack_context__.v({
  "formSuccesContent": "styles-module-scss-module__v-HTta__formSuccesContent",
  "formSuccesOverlay": "styles-module-scss-module__v-HTta__formSuccesOverlay",
  "formSuccessIcon": "styles-module-scss-module__v-HTta__formSuccessIcon",
});
